import React from "react";

function ProjectCard(props) {
  const { style, title, technologies, description, image, link } = props;

  return (
    <div
      className="flex flex-1 m-4 h-full bg-gradient-to-l from-sky-500 to-indigo-500 transition-all rounded-2xl"
      style={style}
    >
      <div
        className="flex flex-col cursor-pointer w-full h-full bg-black transition-all shadow-lg shadow-sky-500 rounded-3xl p-4"
        style={{ transform: "scale(0.98)" }}
      >
        <div>
          <img src={image} alt={title} className="rounded-2xl h-40 w-full" />
        </div>
        <h3 className="text-sm md:text-base font-bold text-sky-300 mt-2">
          {title}
        </h3>
        <div className="mt-1 text-xs font-medium uppercase text-purple-800 space-x-2 space-y-2">
          {technologies.map((technology) => (
            <div
              key={technology.name}
              className={`inline-flex items-center rounded-md bg-red-50 px-2 py-1 
                text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 ${technology.style}`}
              style={{
                fontSize: "x-small",
              }}
            >
              {technology.name}
            </div>
          ))}
        </div>
        <div className="flex-grow overflow-y-auto mt-2 text-black bg-violet-400 h-full rounded-xl no-scrollify">
          <p className="mx-2">{description}</p>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
